(function($, root) {
  "use strict";
  // $.views.settings.allowCode(true);

  $('body').on('click touchstart', '#content-detail button.close', function() {
    $.closeContentDetails();
  });

  $('body').on('click touchstart', '#content-player button.details', function() {
    $.openContentDetails();
  });

  $.openContentDetails = function(content) {
    $.pauseTimer();
    $.pauseAudio();

    $('.detail.mover').css('display', 'flex');
    // $('#content-detail').addClass('fadeIn');
    $('#content-detail').removeClass('fadeOut').addClass('fadeIn').css('display', 'flex');
    $.showContentDetails();
    $.hideContent();
    $.hideTimelines();
    if (window.rdo.audioPlayerDetail) {
      window.rdo.audioPlayerDetail.play();
    } else if (window.rdo.data.selected.content.audio) {

      let divider = 2 * 450 / 250;

      window.rdo.audioPlayerDetail = new $.caPlayer({
        audio: window.rdo.data.selected.content.audio.url,
        size: window.rdo.page.pageheight / divider,
        borderWidth: 2,
        // playedColor: window.rdo.data.selected.content.color,
        backgroundColor: $.hexToRgbA(window.rdo.data.selected.content.color, '.2'),
        text: ''
      });
      // console.log(cap);
      // $('#audio-player').append(cap);
      window.rdo.audioPlayerDetail.appendTo($('#audio-player-detail')[0]);

      window.rdo.audioPlayerDetail.audio.addEventListener('canplaythrough', (function() {
        // console.log('canplaythrough');
        //
        // let duration = window.rdo.audioPlayerDetail.audio.duration * 1000;
        //
        // console.log('dur is:' + duration);

        window.rdo.audioPlayerDetail.play();

      }).bind(this));
    }

  };

  $.closeContentDetails = function(content) {
    $('#content-detail').removeClass('fadeIn').addClass('fadeOut');
    $('.detail.mover').css('display', 'none');
    setTimeout(function() {

      if (window.rdo.audioPlayerDetail) {
        window.rdo.audioPlayerDetail.pause();
      }

      $.hideContentDetails();
      $.showTimelines();
      $.showContent();
      $.startTimerAnimations();
      $.continueTimer();
      $.playAudio();

    }, window.rdo.transitions.transition);
  };

  $('body').on('click touchstart', '#content-detail .detail-content a', function(e) {
    e.preventDefault();
    let url = $(this).attr('href');
    let alt = '';

    if ($(this).find('img').length) {
      alt = $(this).find('img').attr('alt');

      console.log('this is the image:' + url + ' text is:' + alt);

      let contents = {
        contents: [{
          title: alt,
          url: url
        }]
      };

      let galleryTemplate = $.templates('#render-template-gallery');
      $('gallery').html(galleryTemplate.render(contents));
      $.showGallery();
      $.hideContentDetails();

    } else {
      // alt = $(this).attr('alt');
      window.open(url, '_blank');
    }

  });

  $('body').on('click touchstart', 'gallery button.close', function() {
    $.hideGallery();
    $.showContentDetails();

  });

})(jQuery, this);
